import { render, staticRenderFns } from "./Navbutton.vue?vue&type=template&id=baf383f4&scoped=true"
import script from "./Navbutton.vue?vue&type=script&lang=js"
export * from "./Navbutton.vue?vue&type=script&lang=js"
import style0 from "./Navbutton.vue?vue&type=style&index=0&id=baf383f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf383f4",
  null
  
)

export default component.exports